
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { map } from "lodash";
import { searchCustomer } from "@/api/customer";
import {
  getClosingOrderInfo,
  getNotion,
  closingOrderCheck,
  closingOrderCheckSubmit,
  getStateSollbackStatus,
  getClosureType,
  putClosingOrder,
  getRelateOrderId,
  postCheck,
  invalidClosureOrder,
  revertClosureOrder,
} from "@/api/closing-order";
@Component({
  name: "allocateInventory",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  @Prop({ default: null }) private id: null;
  @Prop({ default: null }) private type: null;

  private showCheckSuccess = false;
  private checkSuccessContent = "";
  private showCheckFail = false;
  private checkFailContent = "";
  private showEditDetail = false;
  private editDetailContent = "";
  private showWithdrawOrder = false;
  private withdrawOrder = "";
  private showCancelOrderContent = "";
  private showCancelOrder = false;

  private stateBackList = [];
  private stateBackInfo = null;
  private stateBackDesc  = null;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [
      {
        customerCode: "测试填充",
      },
    ] as any,
  };
  private listParam = {};
  private infoFields = [
    {
      label: "平仓单编号",
      prop: "code",
      key: "code",
    },
    {
      label: "平仓单生成时间",
      prop: "createdAt",
      key: "createdAt",
    },
    {
      label: "当前状态",
      prop: "stateDesc",
      key: "stateDesc",
    },
    {
      label: "平仓类型",
      prop: "typeDesc",
      key: "typeDesc",
      resetKey: { value: "name", label: "desc" },
      options: [],
    },
    {
      label: "公司类型",
      prop: "company",
      key: "company",
      type: "select",
      resetKey: { value: "name", label: "desc" },
      options: [
        { name: "HQ", desc: "华强" },
        { name: "JR", desc: "嘉锐" },
      ],
    },
    {
      label: "客人信息",
      prop: "customerId",
      key: "customerId",
      remote_method: this.getCustomer,
      remote: true,
      type: "select",
      resetKey: { value: "id", label: "abbreviation" },
      options: [],
      filterable: true,
      disabled: false
    },
    {
      label: "关联单据类型",
      prop: "relateType",
      key: "relateType",
      type: "select",
      resetKey: { value: "name", label: "desc" },
      options: [],
    },
    {
      label: "关联单据号",
      prop: "relateCode",
      key: "relateCode",
      type: "select",
      resetKey: { value: "code", label: "code" },
      options: [],
      remote: true,
      clearable: true,
      remote_method: this.getRelateOrderId,
    },
    {
      label: "平仓说明",
      prop: "remark",
      key: "remark",
      type: "textarea",
    },
    {
      label: "注意事项",
      prop: "important",
      key: "important",
    },
  ] as any;
  private info = {
    code: null,
    createdAt: null,
    state: null,
    type: null,
    company: null,
    customerId: null,
    relateCode: null,
    relateType: null,
    remark: null,
    important: null,
  } as any;
  private searchForm = [
    {
      label: "号码查询",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
    },
    {
      label: "华强品名",
      prop: "name",
      key: "name",
      type: "input",
      value: "",
    },
  ];
  private tableCol = [
    {
      label: "询价参照号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "H&Q交易号码",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "接单数量",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "下单数量",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "在库数量",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "平仓后在库数量",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "调配库存产品总数量",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "库存主包装编号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "库存主包装数量",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "",
        },
        {
          name: "指定库存",
          code: "",
          click: "",
        },
      ],
      show: true,
      disabled: false,
      width: 200,
    },
  ] as any;
  private relateOrders = {} as any;
  private getClosureTypeList = [];
  public checkResult = "" as any;
  // private getClosureOrderTypeList = []
  mounted() {
    this.init();
  }
  private async init() {
    await this.getCustomer();
    await this.getClosureType();
    await this.getDet();
  }
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "customerId")
    ].options = res;
    console.log("res", res);
  }
  private async getDet() {
    let params = {
      type: this.type,
    };
    const ress: any = await getNotion(params);
    const res: any = await getClosingOrderInfo(this.id);
    this.info = Object.assign(this.info, res);
    this.info.relateCode = res.relateOrders ? res.relateOrders[0].code : null;
    this.info.orderId = res.relateOrders ? res.relateOrders[0].orderId : null;
    this.info.relateType = res.relateOrders
      ? res.relateOrders
          .map((at) => {
            return at.orderType;
          })
          .toString()
      : null;
    if(this.info.relateType === 'PAYMENT_VOUCHER') {
      this.infoFields.find(e => e.key === 'customerId').disabled = true
    } else {
      this.infoFields.find(e => e.key === 'customerId').disabled = false
    }
    this.info.important = ress.notion;
    this.info.customerId = res.relateOrders
      ? res.relateOrders[0].customer
      : null;
    this.relateOrders = res.relateOrders ? res.relateOrders[0] : null;
    this.infoFields[
      this.infoFields.findIndex((ex) => ex.key === "relateCode")
    ].options = [{ code: this.info.relateCode, orderId: this.info.orderId }];
    if (this.relateOrders) {
      this.getStateSollbackStatus(this.relateOrders);
    }
    if (
      this.getClosureTypeList.findIndex((it) => it.name === this.info.type) > -1
    ) {
      this.infoFields[
        this.infoFields.findIndex((e) => e.key === "relateType")
      ].options =
        this.getClosureTypeList[
          this.getClosureTypeList.findIndex((it) => it.name === this.info.type)
        ].allowOrders;
    }
    if(this.info.relateOrders && this.info.relateOrders.length > 0) {
      if(this.info.relateOrders[0].rollbackState) {
        this.stateBackInfo = this.info.relateOrders[0].rollbackState
        this.stateBackDesc = this.info.relateOrders[0].rollbackStateDesc
      }
    }
  }

  private async getClosureType() {
    const res: any = await getClosureType();
    this.infoFields[
      this.infoFields.findIndex((e) => e.key === "typeDesc")
    ].options = res;
    this.getClosureTypeList = res;
  }

  private async closingOrderCheck() {
    await closingOrderCheck(this.id)
      .then((res) => {
        this.showCheckSuccess = true;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  private async getRelateOrderId(code = null) {
    let params = {
      code: code,
      customerId: this.info.customerId,
      company: this.info.company,
      orderType: this.info.relateType,
    };
    const res: any = await getRelateOrderId(params);
    this.infoFields[
      this.infoFields.findIndex((ex) => ex.key === "relateCode")
    ].options = res;
  }

  private async closingOrderCheckSubmit() {
    let data = {
      id: this.info.id,
      relateOrders: [
        {
          customer: this.info.customerId,
          orderId: this.info.orderId,
          type: this.info.relateType,
          relateType: "MAIN",
          rollbackState: this.stateBackInfo,
        },
      ],
    };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await closingOrderCheckSubmit(data)
      .then((res) => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getDet();
        this.showCheckSuccess = false;
        loading.close();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  private stateBackStatusRow = {} as any;

  private async getStateSollbackStatus(item) {
    let params = {
      orderId: item.orderId,
      orderType: item.orderType,
    };
    const res: any = await getStateSollbackStatus(params);
    this.stateBackStatusRow = res;
    this.stateBackList = res.allowRollbackState ? res.allowRollbackState : {};
  }

  private changeValue({ key, value }) {
    if (key === "type") {
      if (value) {
        if (this.getClosureTypeList.findIndex((it) => it.name === value) > -1) {
          this.infoFields[
            this.infoFields.findIndex((x) => x.key === "relateType")
          ].options =
            this.getClosureTypeList[
              this.getClosureTypeList.findIndex((it) => it.name === value)
            ].allowOrders;
        }
      }
    }
    if (key === "relateCode") {
      console.log("走relateCode了");
      this.info.relateCode = value;
      let newArr =
        this.infoFields[
          this.infoFields.findIndex((ex) => ex.key === "relateCode")
        ].options;
      this.info.orderId = newArr.find((ew) => ew.code === value).orderId;
    }
    if (key === "type") {
      this.info.type = value;
      this.info.relateCode = null
    }
    if (key === "company") {
      this.info.company = value;
      this.info.relateCode = null
    }
    if (key === "customerId") {
      this.info.customerId = value;
      this.info.relateCode = null
    }
    if (key === "relateType") {
      this.info.relateType = value;
      if(value === 'PAYMENT_VOUCHER') {
        this.infoFields.find(e => e.key === 'customerId').disabled = true
      } else {
        this.infoFields.find(e => e.key === 'customerId').disabled = false
      }
      this.info.relateCode = null
    }
  }

  private invalidClosureOrder() {
    this.$confirm("确定作废平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let data = {
          id: this.info.id,
          reason: this.showCancelOrderContent,
        };
        await invalidClosureOrder(data)
          .then((res) => {
            this.getDet();
            this.showCancelOrder = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private revertClosureOrder() {
    this.$confirm("确定撤回平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        // let data = {
        //   id: this.info.id,
        //   // reason: this.withdrawOrder
        // };
        await revertClosureOrder(this.info.id)
          .then((res) => {
            this.getDet();
            this.showWithdrawOrder = false;
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async postCheck() {
    let data = {
      id: this.info.id,
      relateOrders: [
        {
          customer: this.info.customerId,
          orderId: this.info.orderId,
          type: this.info.relateType,
          relateType: "MAIN",
          rollbackState: this.stateBackInfo,
        },
      ],
    };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await postCheck(data)
        .then((res) => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
          this.getDet();
          this.checkResult = res.data?res.data:'操作成功';
          this.showCheckSuccess = true;
          loading.close();
        })
        .catch((error) => {
          this.checkResult =
            error.response.data.message || error.response.data || error.message;
          loading.close();
        });
    } catch (err) {
      // console.log('返回的err',err)
      loading.close();
    }
  }

  private async submitEdit() {
    let data = {
      id: this.info.id,
      company: this.info.company,
      remark: this.info.remark,
      relateOrders: [
        {
          customer: this.info.customerId,
          orderId: this.info.orderId,
          type: this.info.relateType,
          relateType: "MAIN",
        },
      ],
    };
    await putClosingOrder(data)
      .then((res) => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getDet();
        this.showEditDetail = false;
      })
      .catch((err) => {
        console.log(err);
        this.showEditDetail = false;
      });
  }

  private async searchCustomer(name = "") {
    // const res: any = await searchCustomer({ keyword: name });
    // this.searchForm[0].options = res;
  }
}
